import { ROUTER_NAMES } from "@/constants/router.constants"
import FooterLayout from "../layouts/FooterLayout.vue"
import MainLayout from "@/layouts/MainLayout.vue"
import NavLayout from "@/layouts/NavLayout.vue"
import store from "@/store/index.store"
import router from "."
import moment from "moment-timezone"
import { fetchBootcampDetailByKey } from "@/api/bootcamp.api"
import { BOOTCAMP_KEYS } from "@/store/bootcamp-enroll/bootcamp-enroll.constants"

const BootcampEnroll = () =>
  import(
    /* webpackChunkName: "onboarding" */ "@/pages/onboarding/BootcampEnroll"
  )
const BootcampConfirm = () =>
  import(
    /* webpackChunkName: "onboarding" */ "@/pages/onboarding/BootcampConfirm.vue"
  )
const Bootcamp = () =>
  import(/* webpackChunkName: "bootcamp" */ "@/pages/bootcamp.vue")
const Bootcamps = () =>
  import(/* webpackChunkName: "bootcamp" */ "@/pages/bootcamps.vue")

export default [
  {
    path: `/${BOOTCAMP_KEYS.IMPERIAL_HAL}`,
    alias: [
      `/${BOOTCAMP_KEYS.BENJYFISHY}`,
      `/${BOOTCAMP_KEYS.CLIX}`,
      `/${BOOTCAMP_KEYS.DOUBLELIFT}`,
      `/${BOOTCAMP_KEYS.PENGU}`,
      `/${BOOTCAMP_KEYS.SNIP3DOWN}`,
      `/${BOOTCAMP_KEYS.ZOMBS}`,
    ],
    name: ROUTER_NAMES.BOOTCAMP_ENROLL_STATIC,
    component: BootcampEnroll,
    meta: {
      layout: {
        component: FooterLayout,
      },
      settings: {
        staticRender: true,
      },
    },
    beforeEnter: async (to, from, next) => {
      if (to.path.includes(BOOTCAMP_KEYS.CLIX)) {
        await store.dispatch("Optimizely/loadBootcampEnrollTest")
      }
      next()
    },
  },
  {
    path: "/bootcamps/:key/enroll",
    alias: ["/bootcamp/:key/enroll"],
    name: ROUTER_NAMES.BOOTCAMP_ENROLL,
    component: BootcampEnroll,
    meta: {
      layout: {
        component: FooterLayout,
      },
    },
    beforeEnter: async (to, from, next) => {
      if (to.path.includes(BOOTCAMP_KEYS.CLIX)) {
        await store.dispatch("Optimizely/loadBootcampEnrollTest")
      }
      next()
    },
  },
  {
    path: "/bootcamps/:key/confirm",
    alias: ["/bootcamp/:key/confirm"],
    name: ROUTER_NAMES.BOOTCAMP_CONFIRM,
    component: BootcampConfirm,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
  },
  {
    path: "/bootcamps/:key",
    alias: ["/bootcamp/:key"],
    name: ROUTER_NAMES.BOOTCAMP,
    component: Bootcamp,
    meta: {
      layout: {
        component: NavLayout,
      },
    },
    beforeEnter: async (to, from, next) => {
      // Check if the user has access to the specified bootcamp by verifying enrollment and access dates
      let isBootcampAccessible = false
      const bootcampDetails = await fetchBootcampDetailByKey(to.params.key)
      const enrollmentDateData = bootcampDetails?.enrollment_details?.enrolled_at
      if (enrollmentDateData) {
        // If access date is not set, user can access content at any time
        const accessDateData = bootcampDetails?.enrollment_details?.bootcamp_access_at
        if (accessDateData) {
          const accessDate = accessDateData?.date || null
          const accessDateTz = accessDateData?.timezone || "UTC"
          const momentAccessDate = accessDate !== null
            ? moment.utc(moment.tz(accessDate, accessDateTz))
            : null
          isBootcampAccessible = momentAccessDate !== null && momentAccessDate.isBefore(moment.utc())
        } else {
          isBootcampAccessible = true
        }
      }
      if (!isBootcampAccessible) {
        router.replace({
          name: ROUTER_NAMES.SUBSCRIPTION,
        })
      }

      next()
    },
  },
  {
    path: "/bootcamps",
    component: Bootcamps,
    name: ROUTER_NAMES.BOOTCAMPS,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/bootcamp.routes.js